import { axiosInstance } from "../axios";

export function updateSubscription(id, data){
    return axiosInstance.put(`/subscription/my-subscriptions/${id}/`, data)
}